import React, { useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  Divider,
} from "@mui/material";
import {
  Delete,
  DeleteOutline,
  ListAltOutlined,
  PrintRounded,
} from "@mui/icons-material";
import { useReactToPrint } from "react-to-print";
import HeaderPrint from "../headerPrint/HeaderPrint";
import { PaiementType } from "../../types/GlobalType";
import moment from "moment";
import UpdateMontant from "./UpdateMontant.tsx";
import _ from "lodash";
import NoData from "../nodata/NoData.js";

type Props = {
  openDialogHistorique: boolean;
  setOpenDialogHistorique: React.Dispatch<React.SetStateAction<boolean>>;
  id_card: number | string | undefined;
  data: PaiementType[];
};

const DialoguePaiementHistorique = (props: Props) => {
  const orderedData = _.orderBy(props.data, ["paiement_created_at"], ["desc"]);
  const [openEdit, setopenEdit] = useState<boolean>(false);
  const [singleData, setsingleData] = useState<PaiementType>();

  const printRef = useRef<HTMLTableElement | null>(null);

  const handleClickPrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: ".",
  });

  return (
    <>
      {openEdit && <UpdateMontant setOpen={setopenEdit} data={singleData} />}
      <Dialog open={props.openDialogHistorique} fullWidth maxWidth="md">
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItem: "center",
            fontFamily: "poppinsRegular",
            gap: "10px",
          }}
        >
          <ListAltOutlined color="primary" />
          <Typography
            variant="h6"
            color="primary"
            sx={{
              fontWeight: "500",
              fontSize: 15,
              fontFamily: "poppinsRegular",
            }}
          >
            Historique
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ p: 0 }}>
          <DialogContentText>
            {props.data.length > 0 ? (
              <table
                style={{
                  borderCollapse: "collapse",
                  marginLeft: "20px",
                  width: "95%",
                  maxHeight: "100px",
                  padding: "10px 40px",
                }}
                ref={printRef}
              >
                <thead>
                  <tr style={{ backgroundColor: "skyblue" }}>
                    <th colSpan={6}>
                      <HeaderPrint
                        title={"RELEVE DES PAIEMENTS DES FRAIS SCOLAIRES"}
                      />
                    </th>
                  </tr>

                  <tr
                    style={{ fontSize: 13, backgroundColor: "#7e7e7e5f" }}
                    className="print_trimester_unpaid"
                  >
                    <th
                      style={{
                        width: "50px",
                        textAlign: "center",
                        padding: "10px",
                      }}
                    >
                      ID
                    </th>
                    <th
                      style={{
                        width: "100px",
                        textAlign: "center",
                        padding: "20px 0px",
                      }}
                    >
                      Libellé
                    </th>
                    <th
                      style={{
                        width: "100px",
                        textAlign: "center",
                        padding: "20px 0px",
                      }}
                    >
                      Montant
                    </th>
                    <th
                      style={{
                        width: "100px",
                        textAlign: "center",
                        padding: "20px 0px",
                      }}
                    >
                      Date
                    </th>
                    <th
                      style={{
                        width: "100px",
                        textAlign: "center",
                        padding: "20px 0px",
                      }}
                    >
                      Heure
                    </th>
                    <th
                      style={{
                        width: "100px",
                        textAlign: "center",
                        padding: "20px 0px",
                      }}
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {orderedData.map((paiements, index) => {
                    return (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "" : "print_row_color"}
                        style={{
                          fontSize: 13,
                          height: 35,
                          borderBottom: "1px solid #999",
                        }}
                      >
                        <td
                          style={{
                            width: "50px",
                            textAlign: "center",
                          }}
                        >{`0${index + 1}`}</td>
                        <td style={{ width: "100px", textAlign: "center" }}>
                          {"Frais scolaire"}
                        </td>
                        <td style={{ width: "100px", textAlign: "center" }}>
                          {paiements.montant}
                        </td>
                        <td style={{ width: "100px", textAlign: "center" }}>
                          {moment(paiements.paiement_created_at).format(
                            "DD-MM-YYYY"
                          )}
                        </td>
                        <td style={{ width: "100px", textAlign: "center" }}>
                          {moment(paiements.paiement_created_at).format(
                            "hh:mm:ss"
                          )}
                        </td>
                        <td
                          style={{
                            display: "flex",
                            textAlign: "center",
                            justifyContent: "center",
                            gap: 10,
                            // backgroundColor: "red",
                            minWidth: "100%",
                            height: "30px",
                          }}
                        >
                          <span
                            style={{
                              color: "#1647a0e5",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setsingleData(paiements);
                              setopenEdit(true);
                              props.setOpenDialogHistorique(false);
                            }}
                          >
                            Edit
                          </span>
                          {/* <span
                            style={{
                              color: "#cd1e1ef6",
                              cursor: "pointer",
                            }}
                          >
                            Annulé
                          </span> */}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <NoData />
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            gap: "5px",
            mt: "30px",
          }}
        >
          <Button
            variant="text"
            // startIcon={<Undo color="warning" />}
            color="warning"
            onClick={() => props.setOpenDialogHistorique(false)}
            style={{ fontSize: "12px", border: "1px solid #999" }}
          >
            Quitter
          </Button>
          <Button
            variant="text"
            startIcon={<PrintRounded color="primary" />}
            onClick={handleClickPrint}
            style={{ fontSize: "12px", border: "1px solid #999" }}
          >
            {" "}
            Imprimer{" "}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DialoguePaiementHistorique;
